import { useState, useEffect } from "react";

function useSlidePose({ destination = null }, index) {
	const [pose, setPose] = useState('hidden');

	useEffect(() => {
		if (pose === 'hidden' && destination && destination.index === index) {
			setPose('active');
		}
	}, [destination, pose, index]);

	return pose;
}

export default useSlidePose;